import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';

import rootReducer from './reducers';

let middlewares = [thunkMiddleware];

if (process.env.REACT_APP_NODE_ENV === 'development') {
    const logger = createLogger({
        level: 'info',
        collapsed: false,
        logger: console,
        predicate: () => true // eslint-disable-line
    });

    middlewares = [...middlewares, logger, reduxImmutableStateInvariant()];
}

const composeEnhancers = composeWithDevTools({
    serialize: true
});

export default function configureStore(initialState) {
    const store = createStore(
        rootReducer,
        initialState,
        composeEnhancers(applyMiddleware(...middlewares))
    );

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('./reducers', () => {
            const nextRootReducer = require('./reducers'); // eslint-disable-line
            store.replaceReducer(nextRootReducer);
        });
    }

    return store;
}
